import { useEffect, useState } from 'react'

import MuiAvatar from '@mui/material/Avatar'
import { isEmpty } from 'lodash-es'

import { useLoginData } from 'utils/api/hooks'

const DEFAULT_AVATAR = '/img/defaultPhoto.svg'

const Avatar = ({ className, src, ...rest }) => {
  const { me, loggedIn } = useLoginData()

  const [avatarSrc, setAvatarSrc] = useState(DEFAULT_AVATAR)
  useEffect(() => {
    if (me && loggedIn) {
      const thumbImageUrl = me?.avatar?.thumbImage?.url
      setAvatarSrc(isEmpty(thumbImageUrl) ? DEFAULT_AVATAR : thumbImageUrl)
    }
  }, [me, loggedIn])

  return (
    <MuiAvatar
      className={className}
      src={isEmpty(src) ? avatarSrc : src}
      {...rest}
    />
  )
}

export default Avatar
